import { Injectable } from '@angular/core';
import { StorageKeys } from '../enums/StorageKeys.enum';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  /**
   * Clear local and session storage item for the key supplied
   * @param key Key to clear
   */
  clearItem(key: string) {
    localStorage.removeItem(key);
    sessionStorage.removeItem(key);
  }

  set(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  get(key: string) {
    return localStorage.getItem(key);
  }

  /**
   * Get the current bearer-token
   */
  get bearerToken() {
    return localStorage.getItem(StorageKeys.BEARER_TOKEN);
  }
}
